import { OverridableComponent } from '@mui/material/OverridableComponent'
import { SvgIconTypeMap } from '@mui/material/SvgIcon'
import { IQueryParams } from 'src/types/types'

export enum SpaceType {
  ALL = 'all',
  SELF_STORAGE = 'self_storage',
  PARKING = 'parking',
  LAND = 'land',
  WAREHOUSE = 'warehouse',
  INDUSTRIAL_WAREHOUSE = 'industrial_warehouse'
}

export interface SearchFilters {
  search: string
  placeId: string | undefined
  description: string | undefined
  spaceTypes: SpaceType[]
}

type ILabel =
  | 'SEARCH_BAR.ALL_TYPES'
  | 'SEARCH_BAR.SELF_STORAGE'
  | 'SEARCH_BAR.PARKING'
  | 'SEARCH_BAR.LAND'
  | 'SEARCH_BAR.WAREHOUSE'
  | 'SEARCH_BAR.INDUSTRIAL'
  | 'SEARCH_BAR.WHAT_STORING_PARKING'
  | 'SEARCH_BAR.RESET'
  | 'SEARCH_BAR.SHOW_SPACES'

export interface FilterOption {
  id: SpaceType
  label: ILabel
  icon?: string // SVG path
  muiIcon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
  isSelected?: boolean
  query: Partial<IQueryParams>
}

export interface PopupProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
  width?: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  offset?: string
  zIndex?: string
}

type ITitle =
  | 'SEARCH_BAR.WHAT_STORING_PARKING'
  | 'SEARCH_BAR.RESET'
  | 'SEARCH_BAR.SHOW_SPACES'

export interface FiltersContentProps {
  title?: ITitle
  selectedFilters?: SpaceType[]
  onFilterSelect?: (filterId: SpaceType) => void
  onReset?: () => void
  onShowSpaces?: () => void
}
